import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import store from './store';
import Header from './common/header/index';
import Footer from './common/footer/index';
import Home from './pages/home';
import AboutMe from './pages/about-me';
import Achievement from './pages/achievements';
import TechnologyService from './pages/technology-service'
import Partner from './pages/partner'
import Details from './pages/details';
import Resources from './pages/resources';
import ExpertResources from './pages/expertDetail';
import PublishCta from './pages/publish';
import Demand from './pages/demand';
import DemandHall from './pages/demandHall';
import ScrollToTop from './common/scrollToTop';
import Case from './pages/case';

function App() {

  return (
    <Provider store={store}>
      <div className="mian">
        <Router onUpdate={() => window.scrollTo(0, 0)}>
          <Header />
          <div>
            <ScrollToTop>
              <Route path='/' exact component={Home}></Route>
              <Route path='/aboutme' exact component={AboutMe}></Route>
              <Route path="/achievement" exact component={Achievement}></Route>
              <Route path='/technology' exact component={TechnologyService}></Route>
              <Route path='/partner' component={Partner}></Route>
              <Route path="/detail/:id" exact component={Details}></Route>
              <Route path="/resources" component={Resources}></Route>
              <Route path="/expertdetail/:id" exact component={ExpertResources}></Route>
              <Route path="/publish" exact component={PublishCta}></Route>
              <Route path='/demand' exact component={Demand}></Route>
              <Route path="/demandhall" exact component={DemandHall}></Route>
              <Route path="/case/:id" exact component={Case}></Route>
            </ScrollToTop>
          </div>
          <Footer />
        </Router>
      </div>
    </Provider>
  )

}

export default App;